var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',{staticClass:"input_color",attrs:{"id":_vm.id,"type":_vm.type,"placeholder":_vm.placeholder,"browse-text":"Выберите файл"},model:{value:(_vm.newFile),callback:function ($$v) {_vm.newFile=$$v},expression:"newFile"}})}
var staticRenderFns = []

export { render, staticRenderFns }